import InPageSearchCheckBoxGroupStandalone from './InPageSearchCheckBoxGroupStandalone';

export default InPageSearchCheckBoxGroupStandalone;
